__turbopack_context__.v({
  "className": "oktah_a494d8c8-module___-NaSG__className",
  "variable": "oktah_a494d8c8-module___-NaSG__variable",
});
